document.addEventListener('DOMContentLoaded', function () {
    var timerContainer = document.getElementById('countdown-timer');
    var offerBlock = document.getElementById('special-offer-block');
    
    // якщо немає всього блоку — вихід
    if (!offerBlock) return;

    // якщо немає таймера — показуємо блок (все ок)
    if (!timerContainer) return;

    var countdownEl = document.getElementById('countdown');
    var expirationDateStr = timerContainer.getAttribute('data-expiration');
    // Конвертуємо в локальний час браузера, компенсуючи UTC
    var expirationDate = new Date(expirationDateStr);
      expirationDate = new Date(
      expirationDate.getUTCFullYear(),
      expirationDate.getUTCMonth(),
      expirationDate.getUTCDate(),
      expirationDate.getUTCHours(),
      expirationDate.getUTCMinutes(),
      expirationDate.getUTCSeconds()
    );

    function updateCountdown() {
      var now = new Date();
      var diff = expirationDate - now;

      // 🔥 Якщо час вийшов — ховаємо блок повністю
      if (diff <= 0) {
        offerBlock.style.display = 'none';
        clearInterval(interval);
        return;
      }

      // 🔁 Оновлюємо таймер
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      var timeParts = [];

      if (days > 0) {
        timeParts.push(`${days} дн`);
      }

      timeParts.push(
        String(hours).padStart(2, '0') + ':' +
        String(minutes).padStart(2, '0') + ':' +
        String(seconds).padStart(2, '0')
      );

      countdownEl.innerText = timeParts.join(' ');
    }

    updateCountdown();
    var interval = setInterval(updateCountdown, 1000);
  });